import MeetingDetailsModal from './MeetingDetailsModal';

export default MeetingDetailsModal;
